import { defineNuxtPlugin } from 'nuxt/app'

/**
 * This plugin handles HMR for components which are globally registered
 * It runs only on the client side and watches for component updates
 */
export default defineNuxtPlugin({
  name: 'hmr',
  enforce: 'post', // Run after components are registered
  setup() {
    if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
      // Use Vite's HMR API to watch for changes
      if (import.meta.hot) {
        // Track if we've already scheduled a reload to prevent multiple reloads
        let reloadScheduled = false

        // Listen for any update event
        import.meta.hot.on('vite:beforeUpdate', (payload) => {
          if (reloadScheduled) return

          // Check if any of the updated files are am3-generic components (globally registered)
          const hasGlobalComponentUpdate = payload.updates.some(update =>
            update.path.startsWith('/components/')
            && update.path.endsWith('.vue'),
          )

          // Check if vee-validate plugin is being updated to prevent identifier conflicts
          const hasVeeValidateUpdate = payload.updates.some(update =>
            update.path.includes('vee-validate')
            || update.path.includes('plugins/vee-validate')
            || update.path.includes('node_modules/vee-validate'),
          )

          if (hasGlobalComponentUpdate || hasVeeValidateUpdate) {
            // Clear vee-validate state before reload
            if (hasVeeValidateUpdate && window) {
              try {
                const w = window as any
                delete w.__VEE_VALIDATE_PLUGIN_LOADED
                delete w.__VEE_VALIDATE_RULES_CACHE
                delete w.validate
                delete w.__vee_validate_rules
                delete w.__vee_validate_locale
              }
              catch (e) {
                // Ignore cleanup errors
              }
            }

            reloadScheduled = true
            // Force reload the page since globally registered components or vee-validate can't be hot-updated safely
            window.location.reload()
          }
        })

        // Also listen for vite:error to reload on validation errors
        import.meta.hot.on('vite:error', (payload) => {
          if (payload.err && payload.err.message
            && (payload.err.message.includes('has already been declared')
              || payload.err.message.includes('validate'))) {
            if (!reloadScheduled) {
              reloadScheduled = true
              console.warn('Detected identifier conflict, reloading...')
              window.location.reload()
            }
          }
        })
      }
    }
  },
})
